import * as tslib_1 from "tslib";
import * as React from 'react';
import { inject, observer } from 'mobx-react';
import IconButton from 'material-ui/IconButton';
import { FontIcon } from 'material-ui';
var styles = {
    wrapper: {
        margin: '15px 20px',
        padding: '0px 10px',
        backgroundColor: '#fff',
        borderRadius: '5px',
        border: '1px solid #e0e0e0',
        alignItems: 'center'
    },
    container: {
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
    },
    text: {
        fontSize: '15px',
        textAlign: 'center',
        letterSpacing: '3px',
        cursor: 'pointer',
        padding: '15px 0px',
        flex: 1
    },
    side: {
        flex: 1
    },
    buttonFlex: {
        flex: 1
    },
    textFlex: {
        flex: 8
    }
};
var TaskNavigate = /** @class */ (function (_super) {
    tslib_1.__extends(TaskNavigate, _super);
    function TaskNavigate(props) {
        var _this = _super.call(this, props) || this;
        _this.handleBack = function () {
            _this.props.nfcTaskStore.navigateBack();
        };
        return _this;
    }
    TaskNavigate.prototype.render = function () {
        if (!this.props.nfcTaskStore) {
            return null;
        }
        var selectedTask = this.props.nfcTaskStore.selectedTask;
        var runningTask = this.props.nfcTaskStore.getRunningTask();
        var button = selectedTask || runningTask ? (React.createElement("div", { style: styles.container },
            React.createElement("div", { style: styles.buttonFlex },
                React.createElement(IconButton, { onClick: this.handleBack },
                    React.createElement(FontIcon, { className: "material-icons" }, "chevron_left"))),
            React.createElement("div", { style: styles.textFlex },
                React.createElement("span", null, selectedTask ? selectedTask.projectName : runningTask.projectName)))) : null;
        return (React.createElement("div", { style: styles.wrapper },
            React.createElement("div", { style: styles.container },
                React.createElement("div", { style: styles.side }, button),
                React.createElement("div", { style: styles.text },
                    React.createElement("span", null, this.props.nfcTaskStore.title)),
                React.createElement("div", { style: styles.side }))));
    };
    TaskNavigate = tslib_1.__decorate([
        inject('nfcTaskStore'),
        observer
    ], TaskNavigate);
    return TaskNavigate;
}(React.Component));
export { TaskNavigate };



//////////////////
// WEBPACK FOOTER
// ./src/pages/nfctask/TaskNavigate.tsx
// module id = 808
// module chunks = 0